import { firestore, storage, auth, STATE_CHANGED } from "../../firebase";
import UIkit from "uikit";
import {
  LOAD_DATA,
  SET_LOADING,
  RESET_LOADING,
  UPLOAD_PROGRESS,
  LOAD_ALBUMS,
  LOAD_USER_ALBUMS,
} from "../types";
import { Dispatch } from "redux";
import { Track, TPlay, Album } from "../../models/track";

export const getData = () => async (dispatch: Dispatch) => {
  dispatch({
    type: SET_LOADING,
  });
  try {
    let uid = auth.currentUser?.uid;
    if (uid) {
      firestore
        .collection("albums")
        .where("uid", "==", uid)
        .onSnapshot((snap) => {
          if (!snap.empty) {
            let albums: Album[] = [];
            snap.forEach((doc) => {
              let data = doc.data();
              let album: Album = {
                id: doc.id,
                title: data.title,
                tracks: data.tracks,
                covername: data.covername,
                createdAt: data.createdAt,
                uid: data.uid,
                plays: data.plays,
              };

              albums = [...albums, album];
            });
            dispatch({
              type: LOAD_ALBUMS,
              payload: albums,
            });
          } else {
            dispatch({
              type: LOAD_ALBUMS,
              payload: [],
            });
          }
        });
    }

    let songs: Track[] = [];
    let snap = await firestore.collection("songs").get();
    snap.forEach((doc) => {
      let data = doc.data();
      let t: Track = {
        covername: data.covername,
        title: data.title,
        featured: data.featured,
        id: doc.id,
        likes: data.likes,
        plays: data.plays,
        src: data.src,
        tag: data.tag,
        uid: data.uid,
        username: data.username,
        commenting: data.commenting,
        createdAt: data.createdAt,
      };
      data._id = doc.id;
      songs = [...songs, t];
    });

    songs.forEach(async (song) => {
      let url = await storage.ref(`test/${song.src}`).getDownloadURL();

      song.src = url;
    });

    dispatch({
      type: LOAD_DATA,
      payload: songs,
    });
  } catch (err) {
    console.log(err);
  } finally {
    dispatch({
      type: RESET_LOADING,
    });
  }
};

export const getUserAlbums = (username: string) => async (
  dispatch: Dispatch
) => {
  try {
    let albums: Album[] = [];
    let docs = await (
      await firestore
        .collection(`albums`)
        .where("creator", "==", username)
        .get()
    ).docs;

    docs.forEach((doc) => {
      let data = doc.data();
      let album: Album = {
        id: doc.id,
        title: data.title,
        tracks: data.tracks,
        covername: data.covername,
        plays: data.plays,
        uid: data.uid,
        createdAt: data.createdAt,
      };
      albums = [...albums, album];
    });

    dispatch({
      type: LOAD_USER_ALBUMS,
      payload: albums,
    });
  } catch (error) {
    console.log(error);
  }
};

export const likeSong = async (id: string) => {
  try {
    const user = auth.currentUser;
    if (user !== null) {
      let ref = firestore.collection("songs").doc(id);
      let doc = (await ref.get()).data();
      if (doc?.likes.includes(user.uid)) {
        await ref.update({
          likes: doc.likes.filter((id: string) => user.uid !== id),
        });
      } else {
        await ref.update({ likes: [...doc?.likes, user.uid] });
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const createTrack = (track: Track, username: string) => async (
  dispatch: Dispatch
) => {
  dispatch({
    type: SET_LOADING,
  });
  try {
    const user = auth.currentUser;
    if (!user)
      return UIkit.modal.dialog(
        '<p class="uk-modal-body">Login to use this feature</p>',
        { stack: true }
      );
    const { title, imgFile, src, covername, featured, tag, audFile } = track;
    if (!title || !imgFile) {
      return UIkit.modal.dialog(
        '<p class="uk-modal-body">Failed to upload</p>',

        { stack: true }
      );
    } else {
      let t: Track;
      if (!covername) {
        t = {
          title,
          uid: user.uid,
          likes: [],
          src: `${user.uid}${src}`,
          username: username,
          featured,
          tag,
          plays: [],
          createdAt: new Date(Date.now()),
          commenting: true,
        };
      } else {
        t = {
          title,
          uid: user.uid,
          likes: [],
          src: `${user.uid}${src}`,
          username: username,
          covername: covername,
          featured,
          tag,
          plays: [],
          commenting: true,
          createdAt: new Date(Date.now()),
        };

        storage.ref(`covers/${user.uid}${covername}`).put(imgFile);
      }

      UIkit.modal.dialog(
        '<p uk-toggle="target: #uploads-modal" class="uk-modal-body">Uploading track in background, view progress in uploads or click here to view now</p>',
        { stack: true }
      );
      if (audFile) {
        var audioRef = storage.ref(`test/${user.uid}${src}`).put(audFile);

        audioRef.on(
          `state_changed`, // or 'state_changed'
          async (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            switch (snapshot.state) {
              case "paused":
                break;
              case "running":
                console.log("Upload is running");
                dispatch({
                  type: UPLOAD_PROGRESS,
                  payload: {
                    title,
                    progress,
                  },
                });
                if (Math.round(progress) === 100) {
                  await firestore.collection("songs").add(t);

                  UIkit.modal.dialog(
                    '<p class="uk-modal-body">Upload successful</p>',
                    { stack: true }
                  );
                }
                break;
              default:
                break;
            }
          },
          function (error) {
            // A full list of error codes is available at
            // https://google.com/docs/storage/web/handle-errors
            // switch (error.name) {
            //   case "storage/unauthorized":
            //     console.log(` User doesn't have permission to access the object`)
            //     break
            //   case "storage/canceled":
            //     console.log(`cancelled`)
            //     break
            //   case "storage/unknown":
            //     console.log(
            //       `Unknown error occurred, inspect error.serverResponse`
            //     )
            //     break
            //   default:
            UIkit.modal.dialog('<p class="uk-modal-body">Upload failed</p>', {
              stack: true,
            });
            // break
            // }
          }
        );
      }
    }
  } catch (error) {
    console.log(error);
    UIkit.modal.dialog('<p class="uk-modal-body">Upload failed</p>');
    return null;
  } finally {
    dispatch({
      type: RESET_LOADING,
    });
  }
};

export const createAlbum = (album: Album) => async (
  dispatch: Dispatch
): Promise<boolean> => {
  // dispatch({
  //   type: SET_LOADING,
  // });
  try {
    if (album.cover && album.uid) {
      let ref = storage
        .ref(`albums/${album.uid!}/${album.covername!.split(/\s/).join("-")}`)
        .put(album.cover!);

      ref.on(STATE_CHANGED, async (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (Math.round(progress) === 100) {
          let a: Album = {
            title: album.title,
            covername: album.covername,
            createdAt: new Date(Date.now()).toISOString(),
            uid: album.uid,
            plays: [],
            tracks: [],
          };
          firestore
            .collection("albums")
            .add(a)
            .then(() => {
              // dispatch({ type: RESET_LOADING });
              UIkit.modal.dialog(
                '<p class="uk-modal-body">Album created successfully</p>',
                { stack: true }
              );
            });
        }
      });
    }
    return true;
  } catch (error) {
    UIkit.modal.dialog(
      '<p class="uk-modal-body">We could not create your album, Try again</p>',
      { stack: true }
    );
    // dispatch({
    //   type: RESET_LOADING,
    // });
    return false;
  }
};

export const addTrackToAlbum = async (track: Track, id: string) => {
  try {
    let doc = firestore.collection(`albums`).doc(id);
    let data = await (await doc.get()).data();
    let present = data?.tracks.find((t: Track) => t.id === track.id);

    if (!present) {
      await doc
        .update({
          tracks: [...data?.tracks, track],
        })
        .catch((err) => console.log(1000, err));

      return UIkit.modal.dialog(
        `<p class="uk-modal-body">${track.title} added to ${data?.title}</p>`
      );
    } else {
      return UIkit.modal.dialog(
        `<p class="uk-modal-body">${track.title} already in ${data?.title}</p>`
      );
    }
  } catch (error) {
    console.log(error);
    return UIkit.modal.dialog(
      `<p class="uk-modal-body">Failed to add track</p>`
    );
  }
};

export const deleteAlbum = async (album: Album) => {
  storage
    .ref(`albums/${album.uid}/${album.covername?.split(/\s/).join("-")}`)
    .delete()
    .then(() => {
      firestore
        .collection(`albums`)
        .doc(album.id)
        .delete()
        .catch((err) => console.log(err));
    })
    .catch((err) => {
      if (err.code === `storage/object-not-found`)
        firestore
          .collection(`albums`)
          .doc(album.id)
          .delete()
          .catch((err) => console.log(err));
    });
};

export const playsCounter = async (id: string, uid: string) => {
  try {
    const user = auth.currentUser;
    if (user !== null) {
      let ref = firestore.collection("songs").doc(id);
      let doc = (await ref.get()).data();

      let plays: TPlay[] = doc?.plays;
      let play: TPlay = doc?.plays.find((play: any) => play.uid === uid);

      if (play) {
        play.times += 1;
        plays.map((p: TPlay) => {
          if (p.uid === id) {
            return play;
          }
          return p;
        });
        await ref.update({ plays });
      } else {
        play = {
          date: new Date(Date.now()),
          times: 1,
          uid,
        };
        await ref.update({ plays: [...doc?.plays, play] });
      }

      // if (doc?.plays) await ref.update({ plays: [...doc?.plays, user.uid] })
    }
  } catch (error) {
    console.log(error);
  }
};
